import React, { useEffect, useMemo, useState } from 'react'
import { Button, Col, Form, Row, Spinner } from 'react-bootstrap'
import Card from '../../components/Card'
import { FaMagnifyingGlass } from 'react-icons/fa6'
import MasterService from '../../services/master/MasterService'
import { AsyncPaginate } from 'react-select-async-paginate'
import { FaChevronCircleLeft, FaEraser, FaSave } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'
import UserService from '../../services/user/UserService'
import UpiModal from './UpiModal'
import UpiRegModal from './UpiRegModal'
import { formatDateString } from '../../utilities/Utils'
import SweetAlert from 'react-bootstrap-sweetalert'

const UpiAddEdit = () => {

    let masterService = useMemo(() => new MasterService(), [])
    let userService = useMemo(() => new UserService(), [])
    let navigate = useNavigate()

    const [disableForm, setDisableForm] = useState(false)

    useEffect(() => {
        let dataUpiExisting = JSON.parse(localStorage.getItem("dataUpiStorage"))
        console.log(dataUpiExisting)
        if (!dataUpiExisting) return
        const fetchAllData = async () => {
            try {
                setValueIdUpiTrader(dataUpiExisting.idUpiTrader)

                const resUpi = await userService.getUpiById(dataUpiExisting.upiId)
                setValueUpiId(resUpi.data.upiId)
                setValueUpiNama(resUpi.data.upiNama)
                setValueUpiAlamat(resUpi.data.upiAlamat)
                setValueUpiKodepos(resUpi.data.upiKodepos)
                setValueUpiTelp(resUpi.data.upiTelp)

                const resUpiProp = await masterService.getPropinsiById(resUpi.data.upiProp.substring(0, 2))
                setValuePropOpt(resUpiProp.data)

                const resUpiKota = await masterService.getKotaById(resUpi.data.upiKota)
                setValueKotaOpt(resUpiKota.data)

                const resUpiNeg = await masterService.getNegaraById(resUpi.data.upiNeg)
                setValueNegaraOpt(resUpiNeg.data)

                const resUpiReg = await userService.getUpiRegisterById(dataUpiExisting.upiRegId)
                setValueUpiRegId(resUpiReg.data.upiRegId)
                setValueUpiRegNo(resUpiReg.data.upiRegNo)
                setValueUpiRegTgl(resUpiReg.data.upiRegTgl)

                const resUpiRegNeg = await masterService.getNegaraById(resUpiReg.data.upiRegNeg)
                setValueNegaraRegOpt(resUpiRegNeg.data)

                const resUpiRegZonasi = await masterService.getZonasiByKode(resUpiReg.data.upiRegZonasi)
                setValueZonasiOpt(resUpiRegZonasi.data)

            } catch (error) {
                // console.log(error)
            }
        }
        fetchAllData()
    }, [masterService, userService])

    const [valueIdUpiTrader, setValueIdUpiTrader] = useState(null)
    const [valueUpiId, setValueUpiId] = useState(null)
    const [valueUpiNama, setValueUpiNama] = useState(null)
    const [valueUpiAlamat, setValueUpiAlamat] = useState(null)
    const [valueUpiKodepos, setValueUpiKodepos] = useState(null)
    const [valueUpiTelp, setValueUpiTelp] = useState(null)
    const [keyForSecondSelect, setKeyForSecondSelect] = useState(0);
    const [valuePropOpt, setValuePropOpt] = useState(null)
    const [valueKotaOpt, setValueKotaOpt] = useState(null)
    const [valueNegaraOpt, setValueNegaraOpt] = useState(null)

    const [valueUpiRegId, setValueUpiRegId] = useState(null)
    const [valueUpiRegNo, setValueUpiRegNo] = useState(null)
    const [valueUpiRegTgl, setValueUpiRegTgl] = useState(null)
    const [valueNegaraRegOpt, setValueNegaraRegOpt] = useState(null)
    const [valueZonasiOpt, setValueZonasiOpt] = useState(null)

    const loadOptionPropinsi = async (search, loadedOption, { page = 1 }) => {
        const response = await masterService.listPropinsi(search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    const loadOptionKota = async (search, loadedOption, { page = 1 }) => {
        const response = await masterService.listKota(valuePropOpt.kodePropinsi, search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    async function loadOptionNeg(search, loadedOption, { page = 1 }) {
        const response = await masterService.listNegara(search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            addition: {
                page: page + 1
            }
        }
    }

    async function loadOptionNegReg(search, loadedOption, { page = 1 }) {
        const response = await masterService.listNegara(search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            addition: {
                page: page + 1
            }
        }
    }

    async function loadOptionZonasi(search, loadedOption, { page = 1 }) {
        const response = await masterService.listZonasi(page - 1, 20)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 20,
            addition: {
                page: page + 1
            }
        }
    }

    const onChangeOptionProp = e => {
        setValuePropOpt(e)
        setKeyForSecondSelect(prevKey => prevKey + 1)
        setValueKotaOpt(null)
    }

    const onChangeOptionKota = e => {
        setValueKotaOpt(e)
    }

    const onChangeNeg = e => {
        setValueNegaraOpt(e)
    }

    const onChangeNegReg = e => {
        setValueNegaraRegOpt(e)
    }

    const onChangeZonasi = e => {
        setValueZonasiOpt(e)
    }

    const onChangeUpiNama = e => {
        setValueUpiNama(e.target.value)
    }

    const onChangeUpiAlamat = e => {
        setValueUpiAlamat(e.target.value)
    }

    const onChangeUpiKodepos = e => {
        setValueUpiKodepos(e.target.value)
    }

    const onChangeUpiTelp = e => {
        setValueUpiTelp(e.target.value)
    }

    const onChangeUpiRegNo = e => {
        setValueUpiRegNo(e.target.value)
    }

    const onChangeUpiRegTgl = e => {
        setValueUpiRegTgl(e.target.value)
    }

    const handleClickBatal = () => {
        localStorage.removeItem('dataUpiStorage')
        navigate('/setting/upi')
    }

    const [showUpiModal, setShowUpiModal] = useState(false)
    const handleCloseUpiModal = async (row) => {
        setValueUpiId(row.upiId)
        setValueUpiNama(row.upiNama)
        setValueUpiAlamat(row.upiAlamat)
        setValueUpiKodepos(row.upiKodepos)
        setValueUpiTelp(row.upiTelp)
        if (row.upiProp !== undefined) {
            const resUpiProp = await masterService.getPropinsiById(row.upiProp.substring(0, 2))
            setValuePropOpt(resUpiProp.data)
        }

        if (row.upiKota !== undefined) {
            const resUpiKota = await masterService.getKotaById(row.upiKota)
            setValueKotaOpt(resUpiKota.data)

        }

        if (row.upiNeg !== undefined) {
            const resUpiNeg = await masterService.getNegaraById(row.upiNeg)
            setValueNegaraOpt(resUpiNeg.data)
        }

        setShowUpiModal(false)
    }

    const handleClickResetData = () => {
        setValueIdUpiTrader(null)
        setValueUpiId(null)
        setValueUpiNama('')
        setValueUpiAlamat('')
        setValuePropOpt(null)
        setValueKotaOpt(null)
        setValueNegaraOpt(null)
        setValueUpiKodepos('')
        setValueUpiTelp('')
        setValueUpiRegId(null)
        setValueUpiRegNo('')
        setValueUpiRegTgl('')
        setValueNegaraRegOpt(null)
        setValueZonasiOpt(null)
        setDisableForm(false)
    }

    const handleClickCariUpi = () => {
        setShowUpiModal(true)
    }

    const [showUpiRegModal, setShowUpiRegModal] = useState(false)
    const handleCloseUpiRegModal = async (row) => {
        setValueUpiRegId(row.upiRegId)
        setValueUpiRegNo(row.upiRegNo)
        setValueUpiRegTgl(row.upiRegTgl)

        const resUpiRegNeg = await masterService.getNegaraById(row.upiRegNeg)
        setValueNegaraRegOpt(resUpiRegNeg.data)

        const resUpiRegZonasi = await masterService.getZonasiByKode(row.upiRegZonasi)
        setValueZonasiOpt(resUpiRegZonasi.data)

        setShowUpiRegModal(false)
    }
    const handleClickCariUpiReg = () => {
        setShowUpiRegModal(true)
    }

    const [loadingSave, setLoadingSave] = useState(false)
    const [showConfirmSimpanUpi, setShowConfirmSimpanUpi] = useState(false)
    const handleCloseConfirmSimpanUpi = () => setShowConfirmSimpanUpi(false)
    const [showSimpanSuccess, setShowSimpanSuccess] = useState(false)
    const [showSimpanFailed, setShowSimpanFailed] = useState(false)

    const handleClickSimpan = () => {
        setShowConfirmSimpanUpi(true)
    }

    const handleClickProsesSimpan = async () => {
        try {
            setLoadingSave(true)
            let dataUpiExisting = JSON.parse(localStorage.getItem("dataUpiStorage"))
            // console.log(dataUpiExisting)
            let jsonUpi = {
                ...dataUpiExisting,
                idUpiTrader: valueIdUpiTrader !== null ? valueIdUpiTrader : 0,
                upiId: valueUpiId !== null ? valueUpiId : 0,
                upiRegId: valueUpiRegId !== null ? valueUpiRegId : 0,
                upiNama: valueUpiNama,
                upiAlamat: valueUpiAlamat,
                upiKodepos: valueUpiKodepos,
                upiTelp: valueUpiTelp,
                upiNeg: valueNegaraOpt.kodeNegara,
                upiProp: valuePropOpt.kodePropinsi,
                upiKota: valueKotaOpt.kodeKota,
                upiRegNo: valueUpiRegNo,
                upiRegTgl: formatDateString(valueUpiRegTgl),
                upiRegZonasi: valueZonasiOpt.kodeZonasi,
                upiRegNeg: valueNegaraRegOpt.kodeNegara,
                userId: localStorage.getItem('userId'),
                kodeTrader: Number(localStorage.getItem('kodeTrader'))
            }
            // console.log(jsonUpi)
            const resSimpanUpi = await userService.addUpiTrader(jsonUpi)
            if (resSimpanUpi.data.kode === '200') {
                setShowSimpanSuccess(true)
                setShowConfirmSimpanUpi(false)
            } else {
                setShowSimpanFailed(true)
                setShowConfirmSimpanUpi(false)
            }
            setLoadingSave(false)
        } catch (error) {
            setLoadingSave(false)
            setShowSimpanFailed(true)
            setShowConfirmSimpanUpi(false)
        }
    }

    const handleCloseSimpanSuccess = () => {
        setLoadingSave(false)
        setShowSimpanSuccess(false)
        localStorage.removeItem('dataUpiStorage')
        navigate('/setting/upi')
    }

    const handleCloseSimpanFailed = () => {
        setLoadingSave(false)
        setShowSimpanFailed(false)
        localStorage.removeItem('dataUpiStorage')
        navigate('/setting/upi')
    }

    return (
        <>
            <div>
                <Row>
                    <Col sm="12" lg="13">
                        <Card>
                            <Card.Header className="d-flex justify-content-between">
                                <div className="header-title">
                                    <h5 className="card-title">{localStorage.getItem("dataUpiStorage") !== null ? 'Ubah' : 'Tambah'}  Master UPI</h5>
                                </div>
                            </Card.Header>
                            <Card.Body>
                                <div className="row">
                                    <div className="col-sm-10">
                                        <Form>
                                            <Form.Group as={Row} className="form-group">
                                                <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Nama UPI</Form.Label>
                                                <Col sm="5">
                                                    <Form.Control type="text" placeholder="Nama UPI" className="form-control-sm" value={valueUpiNama} onChange={onChangeUpiNama} disabled={disableForm} />
                                                </Col>
                                                <Col sm="1">
                                                    <Button color='outline-primary' size='sm' onClick={() => handleClickCariUpi()}><FaMagnifyingGlass /></Button>
                                                </Col>
                                                <Col sm="4">
                                                    <small>*) Silahkan klik untuk mencari Seluruh Data UPI</small>
                                                </Col>
                                            </Form.Group>
                                        </Form>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-10">
                                        <Form>
                                            <Form.Group as={Row} className="form-group">
                                                <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Alamat UPI</Form.Label>
                                                <Col sm="5">
                                                    <Form.Control as="textarea" rows={3} placeholder="Alamat UPI" className="form-control-sm" value={valueUpiAlamat} onChange={onChangeUpiAlamat} disabled={disableForm} />
                                                </Col>
                                            </Form.Group>
                                        </Form>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-10">
                                        <Form>
                                            <Form.Group as={Row} className="form-group">
                                                <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Propinsi</Form.Label>
                                                <Col sm="5">
                                                    <AsyncPaginate
                                                        loadOptions={loadOptionPropinsi}
                                                        value={valuePropOpt}
                                                        getOptionLabel={(option) => option.uraianPropinsi}
                                                        getOptionValue={(option) => option.kodePropinsi}
                                                        additional={{
                                                            page: 1
                                                        }}
                                                        onChange={onChangeOptionProp}
                                                        isDisabled={disableForm}
                                                    />
                                                </Col>
                                            </Form.Group>
                                        </Form>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-10">
                                        <Form>
                                            <Form.Group as={Row} className="form-group">
                                                <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Kota</Form.Label>
                                                <Col sm="5">
                                                    <AsyncPaginate
                                                        key={keyForSecondSelect}
                                                        loadOptions={loadOptionKota}
                                                        value={valueKotaOpt}
                                                        getOptionLabel={(option) => option.uraianKota}
                                                        getOptionValue={(option) => option.kodeKota}
                                                        additional={{
                                                            page: 1
                                                        }}
                                                        onChange={onChangeOptionKota}
                                                        isDisabled={disableForm}
                                                    />
                                                </Col>
                                            </Form.Group>
                                        </Form>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-10">
                                        <Form>
                                            <Form.Group as={Row} className="form-group">
                                                <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Kode Pos</Form.Label>
                                                <Col sm="2">
                                                    <Form.Control type='text' placeholder="Kode Pos" className="form-control-sm" value={valueUpiKodepos} onChange={onChangeUpiKodepos} disabled={disableForm} />
                                                </Col>
                                            </Form.Group>
                                        </Form>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-10">
                                        <Form>
                                            <Form.Group as={Row} className="form-group">
                                                <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Negara</Form.Label>
                                                <Col sm="3">
                                                    <AsyncPaginate
                                                        loadOptions={loadOptionNeg}
                                                        value={valueNegaraOpt}
                                                        getOptionLabel={(option) => option.kodeNegara + ' - ' + option.uraianNegara}
                                                        getOptionValue={(option) => option.kodeNegara}
                                                        additional={{
                                                            page: 1
                                                        }}
                                                        onChange={onChangeNeg}
                                                        isDisabled={disableForm}
                                                    />
                                                </Col>
                                            </Form.Group>
                                        </Form>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-10">
                                        <Form>
                                            <Form.Group as={Row} className="form-group">
                                                <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Telepon</Form.Label>
                                                <Col sm="3">
                                                    <Form.Control type='text' placeholder="Telepon" className="form-control-sm" value={valueUpiTelp} onChange={onChangeUpiTelp} disabled={disableForm} />
                                                </Col>
                                            </Form.Group>
                                        </Form>
                                    </div>
                                </div>
                                <Card>
                                    <Card.Header>
                                        <div className="header-title">
                                            <h6 className="card-title">Data Nomor Reg, License, HACCP, SKP, atau Nomor Lain</h6>
                                            <small><i>*) Apabila negara MRA diisi No. Reg/License</i></small><br />
                                            <small><i>*) Apabila negara non MRA diisi No. HACCP, SKP, atau Nomor Lain </i></small>
                                        </div>
                                    </Card.Header>
                                    <Card.Body>
                                        <div className="row">
                                            <div className="col-sm-10">
                                                <Form>
                                                    <Form.Group as={Row} className="form-group">
                                                        <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">No Reg License</Form.Label>
                                                        <Col sm="3">
                                                            <Form.Control type="text" placeholder="No Reg License" className="form-control-sm" value={valueUpiRegNo} onChange={onChangeUpiRegNo} disabled={disableForm} />
                                                        </Col>
                                                        <Col sm="1">
                                                            <Button color='outline-primary' size='sm' onClick={() => handleClickCariUpiReg()}><FaMagnifyingGlass /></Button>
                                                        </Col>
                                                        <Col sm="4">
                                                            <small>*) Silahkan klik untuk mencari Nomor yang telah terdaftar</small>
                                                        </Col>
                                                    </Form.Group>
                                                </Form>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-10">
                                                <Form>
                                                    <Form.Group as={Row} className="form-group">
                                                        <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Tanggal</Form.Label>
                                                        <Col sm="2">
                                                            <Form.Control type='date' placeholder="Tanggal" className="form-control-sm" value={valueUpiRegTgl} onChange={onChangeUpiRegTgl} disabled={disableForm} />
                                                        </Col>
                                                    </Form.Group>
                                                </Form>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-10">
                                                <Form>
                                                    <Form.Group as={Row} className="form-group">
                                                        <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Negara</Form.Label>
                                                        <Col sm="3">
                                                            <AsyncPaginate
                                                                loadOptions={loadOptionNegReg}
                                                                value={valueNegaraRegOpt}
                                                                getOptionLabel={(option) => option.kodeNegara + ' - ' + option.uraianNegara}
                                                                getOptionValue={(option) => option.kodeNegara}
                                                                additional={{
                                                                    page: 1
                                                                }}
                                                                onChange={onChangeNegReg}
                                                                isDisabled={disableForm}
                                                            />
                                                        </Col>
                                                    </Form.Group>
                                                </Form>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-10">
                                                <Form>
                                                    <Form.Group as={Row} className="form-group">
                                                        <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Zonasi</Form.Label>
                                                        <Col sm="3">
                                                            <AsyncPaginate
                                                                loadOptions={loadOptionZonasi}
                                                                value={valueZonasiOpt}
                                                                getOptionLabel={(option) => option.kodeZonasi + ' - ' + option.uraianZonasi}
                                                                getOptionValue={(option) => option.kodeZonasi}
                                                                additional={{
                                                                    page: 1
                                                                }}
                                                                onChange={onChangeZonasi}
                                                                isDisabled={disableForm}
                                                            />
                                                        </Col>
                                                    </Form.Group>
                                                </Form>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Card.Body>
                            <Card.Footer>
                                <Button variant="primary" size='sm' onClick={() => handleClickSimpan()}><FaSave /> Simpan</Button>{' '}
                                <Button variant="warning" size='sm' onClick={() => handleClickResetData()}><FaEraser /> Reset</Button>{' '}
                                <Button variant="danger" size='sm' onClick={() => handleClickBatal()}>
                                    <FaChevronCircleLeft /> Kembali
                                </Button>
                            </Card.Footer>
                        </Card>
                    </Col>
                </Row>
                <UpiModal showUpiModal={showUpiModal} handleCloseUpiModal={handleCloseUpiModal} setDisableForm={(setDisableForm)} />
                <UpiRegModal showUpiRegModal={showUpiRegModal} handleCloseUpiRegModal={handleCloseUpiRegModal} upiId={valueUpiId} />
                {
                    showConfirmSimpanUpi &&
                    <SweetAlert
                        title="Simpan Data UPI"
                        warning
                        showCancel
                        confirmBtnText={
                            loadingSave ? (
                                <>
                                    <Spinner animation="border" size="sm" className="me-2" />
                                    Proses Simpan...
                                </>
                            ) : (
                                "Simpan"
                            )
                        }
                        confirmBtnBsStyle="primary"
                        cancelBtnText="Batal"
                        cancelBtnBsStyle="secondary"
                        onConfirm={handleClickProsesSimpan}
                        onCancel={handleCloseConfirmSimpanUpi}
                        focusCancelBtn
                        btnSize="sm"
                        disabled={loadingSave}
                        reverseButtons={true}
                    >
                        {loadingSave && (
                            <div className="text-center">
                                <Spinner animation="border" variant="primary" />
                                <p className="mt-2">Proses Simpan data, harap tunggu...</p>
                            </div>
                        )}
                    </SweetAlert>
                }
                {
                    showSimpanSuccess &&
                    <SweetAlert
                        success
                        title="Simpan Data UPI Berhasil"
                        onConfirm={handleCloseSimpanSuccess}
                        btnSize="sm"
                    />
                }
                {
                    showSimpanFailed &&
                    <SweetAlert
                        danger
                        title="Simpan Data UPI Gagal"
                        onConfirm={handleCloseSimpanFailed}
                        btnSize="sm"
                        timeout={2000}
                    />
                }
            </div>
        </>
    )
}

export default UpiAddEdit